import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import GlobalAnalyticsPage from "./GlobalAnalytics";
import LocalAnalytics from "./LocalAnalytics";

function NumerousEmployeeAnalytics() {
  const [tabValue, setTabValue] = useState("local");

  return (
    <Tabs value={tabValue} onValueChange={(val) => setTabValue(val)}>
      <TabsList>
        <TabsTrigger value="local">Local</TabsTrigger>
        <TabsTrigger value="global">Global</TabsTrigger>
      </TabsList>
      <TabsContent value="global">
        <GlobalAnalyticsPage />
      </TabsContent>
      <TabsContent value="local">
        <LocalAnalytics />
      </TabsContent>
    </Tabs>
  );
}

export default NumerousEmployeeAnalytics;
